export default function constantToTitleCase(value) {
  if (!value) return '';
  return value
    .toLowerCase()
    .replace(/_(.)/g, (_, c) => ` ${c.toLowerCase()}`)
    .replace(/^./, c => c.toUpperCase());
}



// WEBPACK FOOTER //
// ./src/util/filters/index.js